<script>
import { CONSTANTS } from "@/helpers/constants";

export default {
  name: "TV360RequestReceived",
  data() {
    return {};
  },
  methods: {
    goHistory() {
      // Set TV360 tab and select History before navigating (use actions)
      //this.$store.dispatch("routerStore/setIsShowActiveTabs", "tabTV360");
      this.$router.go(-1);
      /*
      this.$nextTick(() => {
        this.$router.replace("/tv360-history");
      });
      */
    },
    color_primary() {
      return CONSTANTS.color_primary;
    },
  },
};
</script>

<template>
  <div class="page-request-received">
    <van-row>
      <van-col span="24">
        <div class="request-received-content">
          <div class="request-received-icon">
            <img src="@/static/icon-processing.svg" />
          </div>
          <div>
            <h4 class="request-received-title">
              {{ $t("tv360.request_received_title") }}
            </h4>
            <p class="request-received-description">
              {{ $t("tv360.request_received_desc") }}
            </p>
            <p class="request-received-sub-description">
              {{ $t("tv360.request_received_check_history") }}
            </p>
          </div>
          <hr class="divider-line" />
        </div>
      </van-col>
      <van-col span="24" class="cs-btn-bill van-payment-success">
        <van-button
          @click="goHistory"
          :color="color_primary()"
          block
          class="btn-home"
          >{{ $t("history") }}</van-button
        >
      </van-col>
    </van-row>
  </div>
</template>

<style scoped>
.page-request-received {
  height: 100vh;
  min-height: 100%;
  background: linear-gradient(180deg, #d2e1f7 0%, #ffffff 35%);
}

.request-received-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding-top: 120px;
  gap: 20px;
}

.divider-line {
  width: 100%;
  border: none;
  border-top: 1px dashed #c9c9c9;
  margin-top: 30px;
}

.request-received-icon {
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.request-received-icon img {
  width: 64px;
  height: 64px;
}

.request-received-title {
  color: #101828;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px;
  margin-bottom: 8px;
}

.request-received-description {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px;
  padding: 0 20px;
}

.request-received-sub-description {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px;
  margin-top: 16px;
  padding: 0 20px;
}

.cs-btn-bill {
  display: flex !important;
  justify-content: center;
}

.van-payment-success {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 16px 16px 32px 16px;
}

.btn-home {
  max-width: 333px;
  max-height: 44px;
  border-radius: 8px;
}
</style>
